
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-b border-yellow-400/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 group cursor-pointer">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/dadfa7b8e8bbab8ae3e8df395caac6f8/302de87561c96b1946ecbbc97f2148e3.png" 
                alt="ARK Construction Consultants Inc Logo"
                className="w-16 h-16 object-contain transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 drop-shadow-lg group-hover:drop-shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl"></div>
            </div>
            <div>
              <h1 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 group-hover:from-yellow-300 group-hover:via-yellow-400 group-hover:to-yellow-500 transition-all duration-300">
                ARK Construction Consultants Inc™
              </h1>
              <p className="text-xs text-slate-400 group-hover:text-slate-300 transition-colors duration-300">Global Smart & Green Building</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-slate-300 hover:text-yellow-400 transition-colors cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-slate-300 hover:text-yellow-400 transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('expertise')}
              className="text-slate-300 hover:text-yellow-400 transition-colors cursor-pointer"
            >
              Expertise
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-slate-300 hover:text-yellow-400 transition-colors cursor-pointer"
            >
              Contact
            </button>
            <Button onClick={() => scrollToSection('contact')} size="sm">
              Get Consultation
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-slate-300 hover:text-yellow-400 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-yellow-400/20">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="text-slate-300 hover:text-yellow-400 transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-slate-300 hover:text-yellow-400 transition-colors text-left cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('expertise')}
                className="text-slate-300 hover:text-yellow-400 transition-colors text-left cursor-pointer"
              >
                Expertise
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-slate-300 hover:text-yellow-400 transition-colors text-left cursor-pointer"
              >
                Contact
              </button>
              <Button onClick={() => scrollToSection('contact')} size="sm" className="w-fit">
                Get Consultation
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}